import { css } from '@emotion/css';

export const inheritFontSizeCss = css`
  a {
    font-size: inherit;
    line-height: inherit;
  }
`;
